import { AWS } from 'aws-sdk'
import { configure } from './../../../config';

const s3Credentials = {
  indentityPoolId: configure.indentityPoolId
}

export const S3Config = {
  endpoint: configure.S3Config.endpoint, //s3Endpoint,
  credentials: s3Credentials,
}